import { useCallback } from "react";
import { useVerificationEmail } from "../../hooks/useVerificationEmail";
import { decrypt } from "../../Utils/encryptdecrypt";

export default function VerifyEmail() {
  const { sentConfirmationEmail } = useVerificationEmail();

  // Grab email from URL instead of prop
  const params = new URLSearchParams(window.location.search);
  const encryptedToken = params.get("token");

  let email = null;
  if (encryptedToken) {
    try {
      email = decrypt(decodeURIComponent(encryptedToken));
    } catch (err) {
      console.error("Invalid or tampered token", err);
    }
  }

  const handleLoginClick = useCallback(async () => {
    try {
      await sentConfirmationEmail(email); // call the API with email from URL
      window.location.href = "/"; // redirect to login
    } catch (error) {
      console.error("Error sending confirmation email:", error);
    }
  }, [email, sentConfirmationEmail]);

  return (
    <div className="min-h-screen flex items-start justify-center py-2 px-4 bg-gray-100">
      <div className="bg-white shadow-lg p-8 max-w-md w-full">
        <h1 className="text-xl font-semibold text-gray-600 mb-2">
          Your email is verified!
        </h1>
        <p className="text-gray-600 mb-4">
          You can now log in to your account and start using Tulip Dojo.
        </p>
        <div className="text-end">
          <button
            onClick={handleLoginClick}
            className="inline-block bg-[#3f51b5] text-white px-6 py-2 transition"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
